import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../api/quarkusApi';

export function useExpense(expenseId) {
  const navigate = useNavigate();

  const [expense, setExpense] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchExpense = useCallback(() => {
    if (!expenseId) {
      setExpense(null);
      return;
    }
    setLoading(true);
    quarkusApi
      .get(`/financial/expenses/${expenseId}`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .then((returnFromApi) => setExpense(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [expenseId, navigate]);

  useEffect(() => {
    fetchExpense();
  }, [fetchExpense]);

  return { expense, isLoading, error, refetch: fetchExpense };
}
